App.controller('ZochLifeInsuranceAddCtrl', ['$scope', '$rootScope', '$sce', '$state', '$http', 'packageService', '$stateParams', 'zochaLifeInsuranceService', 'profileService', 'statesService', 'branchService', '$q', '$mdDialog', 'Config', '$filter', '$timeout', 'lifeInsuranceSharedService', 'zochaWorkersService', 'popUpService', function ($scope, $rootScope, $sce, $state, $http, packageService, $stateParams, zochaLifeInsuranceService, profileService, statesService, branchService, $q, $mdDialog, Config, $filter, $timeout, lifeInsuranceSharedService, zochaWorkersService, popUpService) {

    $scope.stateParams = $stateParams;

    var userData = $stateParams.user;

    $scope.page = 'zoch_life_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Wprowadź deklaracje';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.lifeInsurance.list';
    $scope.$emit('link', $scope.link);

    if (true) {
        $state.go('root.home.zoch.manage');
        return;
    }

    var packageToGroupName = {};
    packageService.dataLifeList().then(function (data) {
        $scope.lifePackages = data.data.group;
        (function () {
            angular.forEach($scope.lifePackages, function (group, groupKey) {
                angular.forEach(group.item, function (single) {
                    packageToGroupName[single.id] = group.code;
                });
            });
        })();
    });

    $scope.isAddressReady = true;

    function triggerAddressReady() {
        $scope.isAddressReady = false;

        $timeout(function () {
            $scope.isAddressReady = true;
        });
    }

    $scope.choose = [];
    $scope.persons = [{}];

    $scope.pesel = null;
    $scope.readByPeselForm = {};
    $scope.alreadyHasDeclaration = null;
    $scope.originalCopyEntered = false;

    var availableModes = [
        {
            name: "Nowa deklaracja",
            id: 'NEW'
        },
        {
            name: "Deklaracja zmiany",
            id: 'CHANGE'
        },
    ];

    var onlyNewModesList = availableModes.slice(0, 1);
    $scope.modesList = onlyNewModesList;
    $scope.currentMode = availableModes[0].id;

    var availablePersonsTypes = [
        {
            "type": "USER",
            "name": "Ubezpieczony pracownik",
            "formOfEmployment": 'CONTRACT_OF_EMPLOYMENT',
        },
        {
            "type": "PARTNER",
            "name": "Współmałżonek lub partner",
        },
        {
            "type": "CHILD",
            "name": "Pełnoletnie dziecko",
        }
    ];

    var onlyUserPersonsTypes = availablePersonsTypes.slice(0, 1);
    $scope.personsTypes = onlyUserPersonsTypes;
    $scope.currentPersonType = availablePersonsTypes[0].type;
    triggerAddressReady();

    var availablePersons = angular.copy(availablePersonsTypes).map(function (personType) {
        personType.person = {
            citizenshipType: "POLISH",
            gender: "FEMALE",
        };
        personType.partner = {
            citizenshipType: 'POLISH',
            gender: "FEMALE"
        };
        personType.assured = [{
            type: 'PERSON',
            country: 'POLISH',
            personBirthdate: null,
            sameAddress: true
        }];
        return personType;
    });

    $scope.isLifePackageHidden = function (person, group, item) {
        return $scope.currentPersonType !== 'USER' && $scope.lifePackages[group].disabledForFamilyMembers;
    };

    var onlyUserPersonsTypes = [availablePersonsTypes[0]];
    var userPerson = availablePersons[0];
    var filledAvailablePersons = angular.copy(availablePersons);

    $scope.dateOriginalCopyEntered = null;
    $scope.addressToApply = undefined;
    var allDeclarations = null;

    function getUserDeclarations(userId) {
        $scope.cans = {};
        return zochaLifeInsuranceService.dataList({
            pageNumber: 0,
            pageSize: 10000,
            userId: userId,
        }).then(function (success) {
            $scope.cans = lifeInsuranceSharedService.canAddPartnerOrSpouse(success.data.data, $scope.currentMode, $scope.currentPerson, availablePersons, $scope.currentPersonType, $scope.personsTypes, true);

            var userDeclarations = success.data.data.filter(function (declaration) {
                return declaration.declaration.type === 'USER';
            });

            var partnerData = {};

            if (userDeclarations.length) {
                $scope.addressToApply = userDeclarations[0].revision.person.address;
                partnerData = userDeclarations[0].revision.partner || {};
            }

            allDeclarations = success.data.data;

            if ($scope.cans.canUserAddPartnerToSelf) {
                if($rootScope.CONFIGURATOR.lifeInsurance.isImprovedCansAndPersonTypeSelectEnabled){
                    $scope.currentPerson.isPartner = false;
                } else {
                    $scope.currentPerson.isPartner = true;
                }
                $scope.currentPerson.partner = angular.merge({citizenshipType: 'POLISH'}, partnerData);
            }

            if ($rootScope.CONFIGURATOR.lifeInsurance.isImprovedCansAndPersonTypeSelectEnabled) {
                $scope.currentPerson = applyDataToPerson($scope.currentPersonType, angular.copy($scope.currentPerson), $scope.currentMode);
            }
        }).catch(function () {
        });
    }

    $scope.changeCurrentMode = function (currentMode) {
        if ($scope.foundUser) {
            var foundIdentifier = $scope.foundUser.person.identifier;
            if (foundIdentifier === $scope.pesel || foundIdentifier === $scope.currentUser.person.identifier) {
                if (allDeclarations === null) {
                    if (!$scope.findPending) {

                        getUserDeclarations($scope.foundUser.userId).then(function () {
                            triggerAddressReady();
                        }).catch(function () {
                            triggerAddressReady();
                        });
                    }
                } else {

                    $scope.cans = lifeInsuranceSharedService.canAddPartnerOrSpouse(allDeclarations, $scope.currentMode, $scope.currentPerson, availablePersons, $scope.currentPersonType, $scope.personsTypes, true);

                    if($rootScope.CONFIGURATOR.lifeInsurance.isImprovedCansAndPersonTypeSelectEnabled){
                        $scope.currentPerson = applyDataToPerson($scope.currentPersonType, angular.copy($scope.currentPerson), $scope.currentMode);
                    }
                    triggerAddressReady();
                }
            }
        }
    };

    if (userData) {
        $scope.currentUser = angular.extend(userData, {
            userId: userData.id
        });
        filledAvailablePersons[0] = angular.extend(availablePersons[0], angular.copy(userPerson), {
            person: userData.person
        });
        filledAvailablePersons[0].branch = {
            id: userData.person.branchId,
            name: userData.person.branch,
        };
        $scope.currentPerson = filledAvailablePersons[0];
        $scope.addressToApply = userData.person.address;


        getUserDeclarations(userData.id).then(function () {
            triggerAddressReady();
        }).catch(function () {
            triggerAddressReady();
        });
        $scope.cans = {};
    } else {
        $scope.currentUser = null;
        $scope.currentPerson = angular.copy(userPerson);
        $scope.cans = {canUserAddPartnerToSelf: true, canAddPartner: true, canAddSpouse: true};
    }

    $scope.findPending = false;

    $scope.foundUser = null;

    function findByIdentifier(identifier) {
        if ($scope.findPending) {
            return;
        }
        $scope.findPending = true;

        return zochaWorkersService.findByIdentifier(identifier).then(function findResponse(response) {
                if ($rootScope.CONFIGURATOR.zoch.lifeInsurance.improvedFindByIdentifierCallback) {
                    var usersList = response.data.data;
                    if (!usersList.length) {
                        $scope.showPopUp('', 'Brak deklaracji', 'Wskazany pracownik nie ma jeszcze deklaracji w systemie, wprowadź nową deklarację.');
                        $scope.alreadyHasDeclaration = false;
                        $scope.currentUser = null;
                        $scope.currentPerson = angular.copy(availablePersonsTypes[0]);

                        $scope.currentPerson.person = {
                            citizenshipType: "POLISH",
                            gender: "FEMALE",
                            address: {},
                            identifier: identifier
                        };
                        $scope.currentPerson.partner = {
                            citizenshipType: 'POLISH',
                            gender: "FEMALE"
                        };
                        $scope.currentPerson.assured = [{
                            type: 'PERSON',
                            country: 'POLISH',
                            personBirthdate: null,
                            sameAddress: true
                        }];

                        if ($scope.branch.length === 1) {
                            $scope.currentPerson.branch = $scope.branch[0];
                        }

                        $scope.modesList = onlyNewModesList;
                        $scope.personsTypes = onlyUserPersonsTypes;

                        return;
                    }

                    var user = usersList[0];

                    $scope.foundUser = user;

                    $scope.currentPersonType = $scope.personsTypes[0].type;
                    $scope.currentMode = $scope.modesList[0].id;

                    return zochaLifeInsuranceService.hasLifeInsuranceDeclarations(user.userId).then(
                        function hasLifeResponse(response) {
                            $scope.alreadyHasDeclaration = response.data.result;
                            $scope.currentUser = user;
                            filledAvailablePersons[0] = angular.extend(availablePersons[0], angular.copy(userPerson), {
                                person: angular.copy(user.person)
                            });
                            filledAvailablePersons[0].branch = {
                                id: user.person.branchId,
                                name: user.person.branch,
                            };

                            $scope.currentPerson = filledAvailablePersons[0];
                            if (!$scope.currentPerson.person.citizenshipType) {
                                $scope.currentPerson.person.citizenshipType = $scope.currentPerson.person.identifierType === 'PESEL' ? 'POLISH' : 'OTHER';
                            }

                            if ($scope.alreadyHasDeclaration) {
                                $scope.modesList = availableModes;
                                $scope.personsTypes = availablePersonsTypes;
                            } else {
                                $scope.modesList = onlyNewModesList;
                                $scope.personsTypes = onlyUserPersonsTypes;

                            }
                        }).then(function () {
                        return getUserDeclarations(user.userId);
                    }).then(function () {
                        $scope.findPending = false;
                    }).catch(function(){
                        $scope.findPending = false;
                    });

                } else {
                    var usersList = response.data.data;
                    if (usersList.length) {
                        var user = usersList[0];
                        return zochaLifeInsuranceService.hasLifeInsuranceDeclarations(user.userId).then(function hasLifeResponse(response) {
                            $scope.alreadyHasDeclaration = response.data.result;
                            $scope.currentUser = user;
                            filledAvailablePersons[0] = angular.extend(availablePersons[0], angular.copy(userPerson), {
                                person: user.person
                            });
                            filledAvailablePersons[0].branch = {
                                id: user.person.branchId,
                                name: user.person.branch,
                            };

                            $scope.currentPerson = filledAvailablePersons[0];

                            if ($scope.alreadyHasDeclaration) {
                                $scope.modesList = availableModes;
                                $scope.personsTypes = availablePersonsTypes;
                            } else {
                                $scope.modesList = onlyNewModesList;
                                $scope.personsTypes = onlyUserPersonsTypes;
                                // $scope.showPopUp('', 'Brak deklaracji', 'Wskazany pracownik nie ma jeszcze deklaracji w systemie, wprowadź nową deklarację.');
                            }
                            $scope.currentPersonType = $scope.personsTypes[0].type;
                            $scope.currentMode = $scope.modesList[0].id;
                        });
                    } else {
                        $scope.alreadyHasDeclaration = false;
                        $scope.currentUser = null;
                        $scope.currentPerson = angular.copy(userPerson);

                        $scope.modesList = onlyNewModesList;
                        $scope.personsTypes = onlyUserPersonsTypes;
                        // $scope.showPopUp('', 'Brak deklaracji', 'Wskazany pracownik nie ma jeszcze deklaracji w systemie, wprowadź nową deklarację.');
                        $scope.currentPersonType = $scope.personsTypes[0].type;
                        $scope.currentMode = $scope.modesList[0].id;
                    }

                }
            }).then(function () {
                $scope.findPending = false;
                triggerAddressReady();
        }).catch(function () {
            $scope.findPending = false;
            triggerAddressReady();
        });
    }

    $scope.findByIdentifier = function () {
        if (!$scope.readByPeselForm.$valid) {
            return;
        }
        findByIdentifier($scope.pesel);
    };

    if (userData && userData.person && userData.person.identifier) {
        $scope.pesel = userData.person.identifier;
        findByIdentifier($scope.pesel);
    }

    $scope.changeCurrentPerson = function (currentPersonType) {
        angular.forEach(availablePersons, function (person) {
            if (person.type === currentPersonType) {
                $scope.currentPerson = person;
            }
        });
        $scope.currentPerson.branch = $scope.currentUser.branch;
        if($rootScope.CONFIGURATOR.lifeInsurance.isImprovedCansAndPersonTypeSelectEnabled){
            $scope.currentPerson = applyDataToPerson(currentPersonType, angular.copy($scope.currentPerson), $scope.currentMode);
        }
        triggerAddressReady();
    };

    function applyDataToPerson(currentPersonType, currentPerson, currentMode) {
        var dataForPersonToApply = $scope.cans._dataToApply[currentPersonType];
        if (currentPerson.person && dataForPersonToApply && currentMode === 'NEW') {
            angular.forEach(Object.keys($scope.cans._dataToApply[currentPersonType]), function (key) {
                currentPerson.person[key] = dataForPersonToApply[key];
            });
        }

        return currentPerson;
    }

    $scope.save = function preSave() {
        var vm = this;

        var el = $(vm.form.$$element[0]).find('button[type="submit"]');

        if ($scope.choose[0] === undefined) {
            $scope.showPopUp('', 'Dokonaj wyboru przy wariantach', 'Aby przejść dalej zaznacz wariant dla ubezpieczonego.');
            return 0;
        }

        if (!vm.form.$valid) {
            $scope.showPopUp('', 'Uzupełnij pola', 'Aby dokończyć rejestrację wypełnij wszystkie wymagane pola.', '');
            document.body.scrollTop = document.documentElement.scrollTop = 80;
            return 0;
        }

        var isPercentageValid = $filter('percentageOfBenefit')($scope.currentPerson.isAssured ? $scope.currentPerson.assured : []);
        if (!isPercentageValid) {
            $scope.showPopUp('', 'Nieprawidłowy procent świadczegnia', 'Procent świadczenia dla wszystkich uposażonych musi się sumować do 100%');
            return 0;
        }

        if (!validateAge($scope.currentPerson.person, $scope.currentPersonType)) {
            return 0;
        }

        var isChange = $scope.currentMode === 'CHANGE';

        if (isChange) {
            save(isChange, el);
        } else {
            zochaLifeInsuranceService.hasDeclarationByTypeAndIdentifier(packageToGroupName[$scope.choose[0]], $scope.currentPerson.person.identifier).then(function (success) {
                console.log('Already has', success.data);
                if (success.data.result) {
                    changeExistingDeclarationPromise().then(function (success) {
                        isChange = true;
                        console.log('isChange', 'confirm', isChange);
                        save(isChange, el);
                    }, function (err) {
                        isChange = false;
                        console.log('isChange', 'cancel', isChange);
                        save(isChange, el);
                    });
                } else {
                    save(isChange, el);
                }

            }, function (error) {

            });
        }


    };

    function save(isChange, el) {
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            el.addClass('disabled');
        }

        if (!$scope.currentPerson.branch || !$scope.currentPerson.branch.id) {
            $scope.currentPerson.branch = {
                id: $scope.currentUser.person.branchId,
                name: $scope.currentUser.person.branch
            };
        }
        var vm = this;
        var toSave = {
            declarations: [{
                acceptedStatements: true,
                branch: {
                    id: $scope.currentPerson.branch.id
                },
                isChange: isChange,
                lifeInsurance: {
                    id: $scope.choose[0]
                },
                person: $scope.currentPerson.person,
                proposedDate: $filter('proposedDate')('life'),
                type: $scope.currentPersonType
            }],
            originalCopyEntered: $scope.originalCopyEntered
        };

        toSave.declarations[0].employmentDate = $filter('getDateFromBirthdate')($scope.currentPerson.employmentDate);
        toSave.declarations[0].formOfEmployment = $scope.currentPerson.formOfEmployment;
        toSave.declarations[0].otherFormOfEmployment = $scope.currentPerson.otherFormOfEmployment;

        if ($scope.currentUser) {
            toSave.userId = $scope.currentUser.userId;
        }

        if ($scope.originalCopyEntered) {
            toSave.signedDate = $filter('getDateFromBirthdate')($scope.dateOriginalCopyEntered);
            toSave.declarations[0].proposedDate = proposedDate($scope.dateOriginalCopyEntered);
        }

        if (typeof $scope.currentPerson.person.address.city === 'object') {
            toSave.declarations[0].person.address.city = $scope.currentPerson.person.address.city.name;
        }

        if ($scope.currentPerson.type === 'SPOUSE') {
            toSave.declarations[0].type = $scope.currentPerson.type;
            toSave.declarations[0].marriageDate = $filter('getDateFromBirthdate')($scope.currentPerson.marriageDate);
        }

        if ($scope.currentPerson.person.citizenshipType === 'POLISH') {
            toSave.declarations[0].person.gender = $filter('getSexFromIdentifier')($scope.currentPerson.person.identifier);
            toSave.declarations[0].person.birthdate = $filter('getDateFromIdentifier')($scope.currentPerson.person.identifier);
        } else {
            toSave.declarations[0].person.birthdate = $filter('getDateFromBirthdate')($scope.currentPerson.person.birthdate);
        }

        if ($scope.currentPerson.isAssured && $scope.currentPerson.assured && $scope.currentPerson.assured.length) {
            for (var a = 0; a < $scope.currentPerson.assured.length; a++) {
                $scope.currentPerson.assured[a].personBirthdate = $filter('getDateFromBirthdate')($scope.currentPerson.assured[a].personBirthdate);
                delete $scope.currentPerson.assured[a].sameAddress;
                if (typeof $scope.currentPerson.assured[a].city === 'object') {
                    $scope.currentPerson.assured[a].city = $scope.currentPerson.assured[a].city.name;
                }
            }
            toSave.declarations[0].assured = $scope.currentPerson.assured;
        }

        if ($scope.currentPerson.isPartner) {
            if ($scope.currentPerson.partner.citizenshipType === 'POLISH') {
                $scope.currentPerson.partner.birthdate = $filter('getDateFromIdentifier')($scope.currentPerson.partner.identifier);
                $scope.currentPerson.partner.identifierType = 'PESEL';
                $scope.currentPerson.partner.gender = $filter('getSexFromIdentifier')($scope.currentPerson.partner.identifier);
            } else {
                $scope.currentPerson.partner.identifierType = 'OTHER';
                $scope.currentPerson.partner.birthdate = $filter('getDateFromBirthdate')($scope.currentPerson.partner.birthdate);
            }

            toSave.declarations[0].partner = $scope.currentPerson.partner;
        }

        //uzupełnienie oświadczeń
        for (var i = 0; i < $scope.data.optionalAgreements.length; i++) {
            var agreeFieldName = 'optionalAgreementAccepted' + (i + 1);
            toSave.declarations[0][agreeFieldName] = $scope.data.optionalAgreements[i].accepted;
        }

        zochaLifeInsuranceService.saveDeclarations(toSave).then(function (success) {
            toSave.saveResponse = success.data;
            $scope.chooseNextStep('', toSave, success.data.familyOfProtectionDeclarationNeeded);
            $timeout(function () {
                el.removeClass('disabled');
            }, 1500);
        }, function (error) {
            // toSave.saveResponse = null;
            if (error.data.message === 'DuplicateIdentifierException') {
                popUpService.showPopUpWithError(error.data, {ev: '', head: 'Zgłoszenie nieudane', content: 'Nie udało się zapisać deklaracji, podany numer PESEL jest już zajęty, użyj innego.', text: '', target: ''});
            } else if (error.data.message === 'DuplicateLoginException') {
                popUpService.showPopUpWithError(error.data, {ev: '', head: 'Zgłoszenie nieudane', content: 'Nie udało się zapisać deklaracji, podany login jest już zajęty, użyj innego.', text: '', target: ''});
            } else if (error.data.message === 'DuplicateEmailException') {
                popUpService.showPopUpWithError(error.data, {ev: '', head: 'Zgłoszenie nieudane', content: 'Nie udało się zapisać deklaracji, podany adres e-mail jest już zajęty, użyj innego.', text: '', target: ''});
            } else if (error.data.message === 'DuplicateHRNumberException') {
                popUpService.showPopUpWithError(error.data, {ev: '', head: 'Uwaga', content: 'Wskazany ' + $rootScope.CONFIGURATOR.hrNumber.nameLong + ' został już przypisany do innego użytkownika. Sprawdź poprawność numeru i spróbuj ponownie. W przypadku problemów prosimy o kontakt z naszą Infolinią.', text: '', target: ''});
            } else {
                popUpService.showPopUpWithError(error.data, {
                    head: 'Wystąpił błąd',
                    content: 'Nie udało się zapisać deklaracji, prosimy spróbować ponownie później.'
                });
            }

            $timeout(function () {
                el.removeClass('disabled');
            }, 1500);
        });
    };

    $scope.addAssured = function () {
        if ($scope.currentPerson['assured'].length < 4) {
            $scope.currentPerson['assured'].push({
                type: 'PERSON',
                country: 'POLISH',
                personBirthdate: null,
                sameAddress: true
            });
        }
    };

    $scope.deleteAssured = function (obj) {
        $scope.currentPerson['assured'].splice(obj, 1);
    };

    $scope.isShowAllDeclarations = false;
    $scope.showAllDeclarations = function (e) {
        e.stopPropagation();
        $scope.isShowAllDeclarations = true;
    };
    $scope.hideAllDeclarations = function () {
        $scope.isShowAllDeclarations = false;
    };

    $scope.data = {};
    $scope.data.agreements = [{
        id: 0,
        content: '<span>Chcę przystąpić do Klubu na warunkach określonych w Regulaminie Klubu. Zapoznałam/em się z jego treścią i akceptuję go.</span>&nbsp;<span class="required">*</span>',
        accepted: false,
        required: true
    },
        {
            id: 1,
            content: '<span>Chcę zostać objęta/y ochroną ubezpieczeniową z sumą ubezpieczenia i na warunkach określonych w umowie, które zostały mi doręczone przed przystąpieniem do ubezpieczenia.</span></span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 2,
            content: '<span>Zgadzam się na założenie przez PZU Życie SA dedykowanego konta elektronicznego (trwały nośnik), na które mogę otrzymywać dokumenty ubezpieczenia, powiadomienia, wnioski i oświadczenia oraz poprzez które mogę zawierać lub przystępować do innych umów ubezpieczenia. Zapoznałam/em się z Regulaminem świadczenia usług drogą elektroniczną i akceptuję jego treść. Zgadzam się na otrzymywanie powiadomień o zmianach zawartości konta za pośrednictwem środków komunikacji elektronicznej (w tym wiadomości sms lub e-mail).',
            accepted: false,
            required: false
        },
        {
            id: 3,
            content: '<span>W razie wystąpienia zdarzenia upoważniam kierownictwo wszystkich placówek służby zdrowia i lekarzy do udzielania PZU Życie SA informacji o moim stanie zdrowia i stanie zdrowia moich małoletnich dzieci, w tym obejmujących: przyczyny hospitalizacji i leczenia ambulatoryjnego, wyniki badań diagnostycznych (z wyłączeniem badań genetycznych), przeprowadzonych konsultacji, wyniki leczenia i rokowań, a także do przekazania kopii mojej dokumentacji medycznej i dokumentacji medycznej moich małoletnich dzieci. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność zakładu ubezpieczeń z tytułu zdarzeń objętych ubezpieczeniem i wysokość świadczenia lub przyczynę śmierci. W razie wystąpienia zdarzenia upoważniam Narodowy Fundusz Zdrowia do przekazania do PZU Życie SA nazw i adresów świadczeniodawców, którzy udzielili mi lub moim małoletnim dzieciom świadczeń opieki zdrowotnej. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność PZU Życie SA oraz wysokość świadczenia. Powyższe upoważnienia obejmują przekazanie informacji lub dokumentacji medycznej również po mojej śmierci lub po śmierci moich małoletnich dzieci.</span></span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 4,
            content: '<span>Zgadzam się na udostępnienie moich danych osobowych i ich dalsze przetwarzanie przez świadczeniodawcę PZU Zdrowie SA, oraz dalsze przekazanie tych danych własnym lub współpracującym placówkom medycznym w celu podjęcia wszelkich działań związanych z organizacją i realizacją świadczeń wynikających z wybranego przeze mnie zakresu świadczeń zdrowotnych.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 5,
            content: '<span>W dniu podpisania deklaracji przystąpienia nie przebywam na zwolnieniu lekarskim, w szpitalu, hospicjum, placówce dla przewlekle chorych, na świadczeniu rehabilitacyjnym oraz nie uznano w stosunku do mnie niezdolności do pracy lub niezdolności do służby orzeczeniem właściwego organu (nie stosuje się w grupowym ubezpieczeniu PZU W RAZIE WYPADKU).</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 6,
            content: '<span>Dodatkowe oświadczenie dotyczące zdrowia, składane wyłącznie przez MAŁŻONKA, PARTNERA ŻYCIOWEGO i PEŁNOLETNIE DZIECKO, przystępujących do grupowego ubezpieczenia typ P Plus o kodzie PTGP34 oraz ubezpieczeń dodatkowych, którzy bezpośrednio przed przystąpieniem do ubezpieczenia albo nie byli objęci innym ubezpieczeniem grupowym na życie w PZU Życie SA, albo byli objęci takim ubezpieczeniem krócej niż 12 miesięcy.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 7,
            content: '<span>Wyrażam zgodę na przetwarzanie przez PZU Życie SA moich danych osobowych dotyczących stanu zdrowia zawartych w deklaracji przystąpienia do ubezpieczenia – w celu przystąpienia oraz wykonywania umowy ubezpieczenia, a także przekazanych PZU Życie SA przez placówki służby zdrowia, lekarzy lub przeze mnie w trakcie obowiązywania umowy ubezpieczenia – w celu wykonania umowy ubezpieczenia. Zgoda jest dobrowolna, ale konieczna w celu realizacji umowy.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
        {
            id: 8,
            content: '<span>Wyrażam zgodę na udostępnienie przez PZU Życie SA moich danych osobowych podmiotom z grupy PZU, tj. PZU SA, PTE PZU SA, TFI PZU SA, PZU Pomoc SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA, w ich własnych celach marketingowych, obejmujących profilowanie zmierzające do określenia preferencji lub potrzeb w zakresie produktów ubezpieczeniowych i innych produktów finansowych oraz przedstawienia odpowiedniej oferty.</span>',
            accepted: false,
            required: false
        },
        {
            id: 9,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
            accepted: false,
            required: false
        },
        {
            id: 10,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU Pomoc SA, oraz jej partnerów handlowych informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
            accepted: false,
            required: false
        },
        {
            id: 11,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR).</span>',
            accepted: false,
            required: false
        },
        {
            id: 12,
            content: '<span>Wyrażam zgodę na otrzymywanie od PZU Pomoc SA i jej partnerów handlowych informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR).</span>',
            accepted: false,
            required: false
        },
        {
            id: 13,
            content: '<span>Wyrażam zgodę na przetwarzanie moich danych osobowych przez PZU Życie SA w celu przekazywania mi treści marketingowych dotyczących produktów ubezpieczeniowych i innych produktów finansowych, kiedy nie będę posiadać ubezpieczenia w tej firmie.</span>',
            accepted: false,
            required: false
        },
        {
            id: 14,
            content: '<span>Wyrażam zgodę na przesyłanie informacji, które mają związek z moim ubezpieczeniem w PZU Życie SA za pośrednictwem środków komunikacji elektronicznej, w tym wiadomości SMS/MMS lub e-mail, na wskazany przeze mnie numer telefonu lub adres mailowy. W razie zmiany podanych przeze mnie danych kontaktowych, zobowiązuję się uaktualniać moje dane, dzięki którym będę otrzymywać informacje za pośrednictwem środków komunikacji elektronicznej.</span>',
            accepted: false,
            required: false
        },
        {
            id: 15,
            content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie Informacja Administratora danych osobowych (PZU Życie SA).</span>',
            accepted: false,
            required: true
        },
        {
            id: 16,
            content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie Informacja Administratora danych osobowych (PZU Pomoc SA).</span>',
            accepted: false,
            required: true
        }];

    $scope.data.requiredAgreements = $scope.data.agreements.filter(function (single) {
        return single.required;
    });
    $scope.data.optionalAgreements = $scope.data.agreements.filter(function (single) {
        return !single.required;
    });

    $scope.showPopUp = function (ev, head, content, text, target, exitOrReload, config) {

        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'locals', function ($scope, $mdDialog, locals) {
                $scope.locals = locals;
                $scope.config = config;

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.confirm = function () {
                    $mdDialog.hide($scope.locals);
                };
            }],
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {
            if (!!config && !!config.confirmCallback) {
                config.confirmCallback(data);
            }
        }, function (data) {
            if (!!config && !!config.cancelCallback) {
                config.cancelCallback(data);
            }
        });
    };


    function changeExistingDeclarationPromise() {
        return $q(function (resolve, reject) {
            var config = {
                cancelButton: "Nie",
                cancelCallback: function (data) {
                    reject(data);
                },
                confirmCallback: function (data) {
                    resolve(data);
                },
            };
            $scope.showPopUp('', 'Deklaracja już istnieje', 'Podobna deklaracja już istnieje. Czy chcesz nadpisać istniejącą?', 'Tak', null, true, config);
        });

    }

    var getResults = function (query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function (data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function (query) {
        if (!query) {
            return;
        }

        return getResults(query).then(function (results) {
            return results;
        });
    };

    var companyId = 1;
    $scope.branch = [];
    branchService.dataZochBranchLists(companyId).then(function (data) {
        $scope.branch = data.data.data;

        if ($scope.branch.length === 1) {
            $scope.currentPerson.branch = $scope.branch[0];
        }
    });

    // ##### FILTER ##### //
    $scope.querySearchBranch = function (query) {
        var results = query && $scope.branch.length ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    /**
     * Check if a person complies with the age restrictions;
     */
    function validateAge(person, personType) {
        if (person.citizenshipType === 'POLISH') {
            if (personType === 'USER') {
                if (!$filter('isOver16FromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić tylko osoby, które ukończyły 16 lat', '');
                    return 0;
                }
            } else {
                if ($filter('isNoAdultFromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić tylko osoby pełnoletnie', '');
                    return 0;
                }
            }
            if ($filter('isOver75FromIdentifier')(person.identifier)) {
                $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                return 0;
            }
        } else {
            if (personType === 'USER') {
                if (!$filter('isOver16FromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić tylko osoby, które ukończyły 16 lat', '');
                    return 0;
                }
            } else {
                if ($filter('isNoAdultFromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić tylko osoby pełnoletnie', '');
                    return 0;
                }
            }
            if ($filter('isOver75FromBirthdate')(new Date(person.birthdate))) {
                $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                return 0;
            }
        }

        return true;
    }

    $scope.additional = {
        notExistEmail: false,
        notExistPhone: false
    };

    $scope.$watch('additional.notExistEmail', function (oldVal, newVal) {
        console.log(oldVal, newVal);
        if (oldVal !== newVal) {
            if ($scope.additional.notExistEmail) {
                $scope.currentPerson.person.email = '';
            }
        }
    }, true);

    $scope.$watch('additional.notExistPhone', function (oldVal, newVal) {
        console.log(oldVal, newVal);
        if (oldVal !== newVal) {
            if ($scope.additional.notExistPhone) {
                $scope.currentPerson.person.phone = '';
            }
        }
    }, true);

    function PopUpChooseCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpChooseCtrl.$inject = ['$scope', '$mdDialog', 'locals'];
    $scope.chooseNextStep = function (ev, toSave, familyOfProtectionDeclarationNeeded) {
        zochaLifeInsuranceService.get(toSave.saveResponse.declarations[0].uuid).then(function (data) {
            let declaration = data.data.declaration;
            let revision = data.data.revision;
            $mdDialog.show({
                controller: PopUpChooseCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/choose-next-step.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    toSave: toSave,
                    familyOfProtectionDeclarationNeeded: familyOfProtectionDeclarationNeeded,
                    barcode: declaration.barcode,
                    policyNumber: revision.lifeInsurancePolicyNumber,
                    insured: revision.person.firstName + " " + revision.person.lastName,
                }
            });
        });
    };

    function proposedDate(date) {
        var date = new Date(date);
        var dayOfMonth = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var requiredDayOfMonth = 20;
        var proposedDate = null;

        if (dayOfMonth <= requiredDayOfMonth) {
            // to najbliższy
            var date = new Date(date.getFullYear(), date.getMonth() + 1);
            var formattedDate = moment(date).format('YYYY-MM-DD');
            proposedDate = formattedDate;
        } else {
            // to +1 miesiąc
            var date = new Date(date.getFullYear(), date.getMonth() + 2);
            var formattedDate = moment(date).format('YYYY-MM-DD');
            proposedDate = formattedDate;
        }

        return proposedDate;
    }

    $scope.assuredTypeChanged = function (currentAssured) {
        if (currentAssured.type === 'ORGANIZATION') {
            currentAssured.city = '';
            currentAssured.street = '';
            currentAssured.number = '';
            currentAssured.apartment = '';
            currentAssured.zipCode = '';
        }
    };

    $scope.$watch('currentPerson', function (oldVal, newVal) {
        if (!$scope.currentPerson || !$scope.currentPerson.assured) {
            return 0;
        }
        for (var a = 0; a < $scope.currentPerson.assured.length; a++) {
            var currentAssured = $scope.currentPerson.assured[a];
            if (currentAssured.sameAddress && currentAssured.type !== 'ORGANIZATION') {
                if ($scope.currentPerson.person.address) {
                    currentAssured.city = $scope.currentPerson.person.address.city;
                    currentAssured.street = $scope.currentPerson.person.address.street;
                    currentAssured.number = $scope.currentPerson.person.address.number;
                    currentAssured.apartment = $scope.currentPerson.person.address.apartment;
                    currentAssured.zipCode = $scope.currentPerson.person.address.zipCode;
                }
            }
        }
    }, true);
}]);
